import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BlockDomain } from '../model';

@Injectable()
export class AdminBlockDomainsApi {
  protected basePath = `${environment.API_V4}/admin/block-domains`;

  constructor(protected http: HttpClient) {}

  domains() {
    return this.http.get<BlockDomain[]>(this.basePath);
  }

  delete(domainId: string) {
    const path = `${this.basePath}/${domainId}`;
    return this.http.delete<void>(path);
  }

  createDomain(domain: BlockDomain) {
    const path = `${this.basePath}`;
    return this.http.post<BlockDomain>(path, domain);
  }

  updateDomain(domain: BlockDomain) {
    const path = `${this.basePath}/${domain.id}`;
    return this.http.patch<BlockDomain>(path, domain);
  }
}
